import "./ScheduleATour.module.css";
import Header from "@/reusable_sections/Header";
import VisitOurHome from "./sections/VisitOurHome";
import SimpleSteps from "./sections/SimpleSteps";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ScheduleATourPage() {
  return <div>
      <Header />
      <VisitOurHome />
      <SimpleSteps />
      <CommonQuestions />
      <Footer />
    </div>;
}